import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=7e11a222&scoped=true"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"
import style0 from "./customButton.vue?vue&type=style&index=0&id=7e11a222&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e11a222",
  null
  
)

export default component.exports